import { HTMLAttributes } from "react";

export const BlingIcon: React.FC<HTMLAttributes<SVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="109"
    height="90"
    viewBox="0 0 109 90"
    fill="none"
    {...props}
  >
    <path
      d="M11.6587 37.2917L8 36L1.88477 33.4224M21.5288 19.5969L17 15.2783L15.3844 13.0208M39.1065 15.2783L38.5 12L36.9568 5.65396M61.8825 15.2783L63 9L64.8089 1.9004M91.2495 34.5532L97.5 31.5L100.885 29.5532M95.6123 49.6179L100.5 50L107.261 50.3669M95.6123 65.1179L103 68.5L106.531 69.7269M86.8845 79.1179L89 83L92.7534 87.8401M76.994 22.8361L80.5 17.5L86.8845 10.1181"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
